module.exports = __webpack_public_path__ + "assets/b68.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b68.png
// module id = 658
// module chunks = 0